(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrix-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ntx-cart]');
    if (!root) return;

    var body = root.querySelector('[data-ntx-cart-body]');
    var foot = root.querySelector('[data-ntx-cart-foot]');
    var countEl = root.querySelector('[data-ntx-cart-count]');
    var subtotalEl = root.querySelector('[data-ntx-cart-subtotal]');

    function open() {
      root.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      root.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-ntx-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
    });

    function fmtMoney(cents) {
      var n = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return '$' + n + ' MXN';
    }

    function render(cart) {
      countEl.textContent = cart.item_count || 0;
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML =
          '<div class="ntx-cart__empty">' +
            '<p class="ntx-cart__empty-title">Tu carrito está vacío</p>' +
            '<p class="ntx-cart__empty-sub">Empieza por explorar nuestros productos.</p>' +
            '<a href="/collections/all" class="ntx-cart__empty-cta">Ver todos los productos</a>' +
          '</div>';
        foot.setAttribute('hidden', '');
        return;
      }
      var html = '<div class="ntx-cart__list">';
      cart.items.forEach(function (item) {
        var imgUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
        var img = imgUrl ? '<img src="' + imgUrl + '" alt="' + (item.product_title || '') + '" loading="lazy">' : '';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        html += '<div class="ntx-cart__item" data-key="' + item.key + '">' +
                  '<div class="ntx-cart__item-img">' + img + '</div>' +
                  '<div class="ntx-cart__item-body">' +
                    '<a href="' + item.url + '"><p class="ntx-cart__item-title">' + item.product_title + '</p></a>' +
                    (variantTitle ? '<span class="ntx-cart__item-variant">' + variantTitle + '</span>' : '') +
                    '<div class="ntx-cart__item-controls">' +
                      '<button type="button" class="ntx-cart__qty-btn" data-ntx-qty-down>−</button>' +
                      '<span class="ntx-cart__qty-val">' + item.quantity + '</span>' +
                      '<button type="button" class="ntx-cart__qty-btn" data-ntx-qty-up>+</button>' +
                    '</div>' +
                  '</div>' +
                  '<div class="ntx-cart__item-right">' +
                    '<span class="ntx-cart__item-price">' + fmtMoney(item.final_line_price) + '</span>' +
                    '<button type="button" class="ntx-cart__item-remove" data-ntx-remove>Quitar</button>' +
                  '</div>' +
                '</div>';
      });
      html += '</div>';
      body.innerHTML = html;
      subtotalEl.textContent = fmtMoney(cart.total_price);
      foot.removeAttribute('hidden');

      // Wire up qty/remove
      body.querySelectorAll('.ntx-cart__item').forEach(function (itemEl) {
        var key = itemEl.getAttribute('data-key');
        var qtyVal = itemEl.querySelector('.ntx-cart__qty-val');
        itemEl.querySelector('[data-ntx-qty-down]').addEventListener('click', function () {
          updateQty(key, parseInt(qtyVal.textContent, 10) - 1);
        });
        itemEl.querySelector('[data-ntx-qty-up]').addEventListener('click', function () {
          updateQty(key, parseInt(qtyVal.textContent, 10) + 1);
        });
        itemEl.querySelector('[data-ntx-remove]').addEventListener('click', function () {
          updateQty(key, 0);
        });
      });
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    function updateQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      }).then(function (r) { return r.json(); }).then(render);
    }

    // Inicializar count en header
    fetchCart().then(function (cart) {
      countEl.textContent = cart.item_count || 0;
      // Update header cart badge si existe
      var headerBadge = document.querySelector('.ntx-header__cart-count, [data-cart-count]');
      if (headerBadge) headerBadge.textContent = cart.item_count;
    });

    // Interceptar TODOS los forms de ATC en la página
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); }).then(function () {
        return fetchCart();
      }).then(function (cart) {
        render(cart);
        open();
      }).catch(function () {
        // fallback: submit nativo
        form.submit();
      });
    });

    // Trigger desde icono cart del header (si existe)
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ntx-cart-open], a[href="/cart"], a[href*="/cart"]');
      if (!t) return;
      // Solo interceptar si NO es Ctrl/Cmd+click (abrir nueva pestaña)
      if (e.ctrlKey || e.metaKey) return;
      // Si es el link "Ver carrito completo" del drawer, dejarlo pasar
      if (t.classList.contains('ntx-cart__view')) return;
      e.preventDefault();
      fetchCart().then(function (cart) {
        render(cart);
        open();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrix-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      if (!root.classList.contains('ntx-buybox')) return;

      // Gallery: thumbs sync with slides (mobile scroll, desktop click)
      var slides = root.querySelectorAll('.ntx-buybox__slide');
      var thumbs = root.querySelectorAll('.ntx-buybox__thumb');
      var slidesContainer = root.querySelector('.ntx-buybox__slides');
      var isDesktop = window.matchMedia('(min-width: 900px)').matches;

      function setActive(idx) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      }

      if (isDesktop && slides.length) setActive(0);

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(thumb.getAttribute('data-target'), 10);
          if (isDesktop) {
            setActive(idx);
          } else {
            var target = slides[idx];
            if (target && slidesContainer) {
              slidesContainer.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
            }
          }
        });
      });

      // Mobile: update active thumb on scroll
      if (slidesContainer && !isDesktop) {
        slidesContainer.addEventListener('scroll', function () {
          var idx = Math.round(slidesContainer.scrollLeft / slidesContainer.clientWidth);
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        }, { passive: true });
      }

      // Variant pills update price + select
      var pills = root.querySelectorAll('.ntx-buybox__pill');
      var select = root.querySelector('.ntx-buybox__variant-select');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var oneTimeEl = root.querySelector('[data-onetime-price]');
      var subEl = root.querySelector('[data-sub-price]');
      var subDiscount = parseFloat(root.getAttribute('data-sub-discount') || '15');

      function formatMoney(cents) {
        var n = (cents / 100);
        return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';
      }

      pills.forEach(function (pill) {
        var input = pill.querySelector('input');
        if (!input) return;
        input.addEventListener('change', function () {
          var name = input.name;
          root.querySelectorAll('input[name="' + CSS.escape(name) + '"]').forEach(function (o) {
            o.closest('.ntx-buybox__pill').classList.toggle('is-selected', o.checked);
          });
        });
      });

      // Purchase option: visual sync + actualiza [data-price] + hidden selling_plan
      var purchaseOpts = root.querySelectorAll('.ntx-buybox__purchase-opt input');
      var spInput = root.querySelector('[data-selling-plan-input]');
      function applyPurchaseChoice() {
        var checked = root.querySelector('.ntx-buybox__purchase-opt input:checked');
        if (!checked) return;
        purchaseOpts.forEach(function (o) {
          o.closest('.ntx-buybox__purchase-opt').classList.toggle('is-selected', o.checked);
        });
        // Update hidden selling_plan input (used by ATC form submission)
        if (spInput) spInput.value = checked.getAttribute('data-selling-plan') || '';
        // Update visible main price below
        if (priceEl) {
          if (checked.value === 'subscribe' && subEl && subEl.textContent) {
            priceEl.textContent = subEl.textContent.replace(' MXN','');
          } else if (oneTimeEl && oneTimeEl.textContent) {
            priceEl.textContent = oneTimeEl.textContent.replace(' MXN','');
          }
        }
      }
      purchaseOpts.forEach(function (input) {
        input.addEventListener('change', applyPurchaseChoice);
      });

      // Update sub price = onetime * (1 - discount/100)
      function syncSubPrice() {
        if (!subEl || !oneTimeEl) return;
        var sel = select ? select.options[select.selectedIndex] : null;
        var price = sel ? parseInt(sel.getAttribute('data-price'), 10) : null;
        if (price == null && priceEl) {
          var match = priceEl.textContent.replace(/[^\d]/g, '');
          price = parseInt(match, 10);
        }
        if (!price || isNaN(price)) return;
        var subPrice = Math.round(price * (1 - subDiscount / 100));
        subEl.textContent = formatMoney(subPrice);
        oneTimeEl.textContent = formatMoney(price);
        // Re-aplica el precio visible según radio actual
        applyPurchaseChoice();
      }
      syncSubPrice();
      // Re-syncroniza precio cuando cambia variante (variant pills update [data-price])
      if (select) select.addEventListener('change', function(){ setTimeout(syncSubPrice, 50); });
      root.querySelectorAll('.ntx-buybox__pill--variant input').forEach(function(p){
        p.addEventListener('change', function(){ setTimeout(syncSubPrice, 50); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrix-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ntx-search]');
    if (!root) return;

    var input = root.querySelector('[data-ntx-search-input]');
    var resultsBox = root.querySelector('[data-ntx-search-results]');
    var emptyTpl = resultsBox.innerHTML;
    var debounceTimer;
    var lastQuery = '';

    function open() {
      root.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input && input.focus(); }, 100);
    }
    function close() {
      root.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    // Auto-inyectar trigger en header
    function injectTrigger() {
      if (document.querySelector('.ntx-header-search-trigger')) return;
      var actions = document.querySelector('.ntx-header__actions, .ntx-header__icons, .ntx-header nav');
      if (!actions) {
        // fallback: si no hay header custom, esconder el feature
        return;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ntx-header-search-trigger';
      btn.setAttribute('aria-label', 'Buscar');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>';
      btn.addEventListener('click', open);
      actions.insertBefore(btn, actions.firstChild);
    }
    if (document.readyState !== 'loading') injectTrigger();
    else document.addEventListener('DOMContentLoaded', injectTrigger);

    // Close handlers
    root.querySelectorAll('[data-ntx-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
    });

    // Predictive search
    function fetchResults(q) {
      if (!q || q.length < 2) {
        resultsBox.innerHTML = emptyTpl;
        return;
      }
      lastQuery = q;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== lastQuery) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            resultsBox.innerHTML = '<p class="ntx-search__no-results">No encontramos resultados para <strong>' + q + '</strong>.</p>';
            return;
          }
          var html = '<div class="ntx-search__list">';
          products.forEach(function (p) {
            var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
            html += '<a class="ntx-search__result" href="' + p.url + '">' +
                      '<span class="ntx-search__result-img">' + img + '</span>' +
                      '<span class="ntx-search__result-body">' +
                        '<span class="ntx-search__result-name">' + p.title + '</span>' +
                        '<span class="ntx-search__result-meta">' + (p.product_type || p.vendor || '') + '</span>' +
                      '</span>' +
                      '<span class="ntx-search__result-price">' + (p.price || '') + '</span>' +
                    '</a>';
          });
          html += '</div>';
          html += '<a class="ntx-search__view-all" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados</a>';
          resultsBox.innerHTML = html;
        })
        .catch(function () {
          resultsBox.innerHTML = '<p class="ntx-search__no-results">Hubo un problema. Intenta de nuevo.</p>';
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = input.value.trim();
        debounceTimer = setTimeout(function () { fetchResults(q); }, 220);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrix-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sticky = document.querySelector('[data-ntx-sticky-atc]');
    if (!sticky) return;

    var mq = window.matchMedia('(max-width: 899px)');
    if (!mq.matches) return;

    var origForm = document.querySelector('.ntx-buybox__form');
    var origAtc = document.querySelector('.ntx-buybox__atc');
    var stickyBtn = sticky.querySelector('[data-ntx-sticky-atc-btn]');
    var stickyPrice = sticky.querySelector('[data-ntx-sticky-price]');
    var origPrice = document.querySelector('.ntx-buybox__price');

    if (!origAtc) return;

    function show() {
      sticky.removeAttribute('hidden');
      document.body.classList.add('ntx-sticky-atc-active');
    }
    function hide() {
      sticky.setAttribute('hidden', '');
      document.body.classList.remove('ntx-sticky-atc-active');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          hide();
        } else if (window.scrollY > 200) {
          show();
        }
      });
    }, { rootMargin: '0px 0px -120px 0px', threshold: 0 });

    observer.observe(origAtc);

    stickyBtn.addEventListener('click', function () {
      if (origForm && typeof origForm.requestSubmit === 'function') {
        origForm.requestSubmit();
      } else if (origForm) {
        origForm.submit();
      } else {
        origAtc.click();
      }
    });

    if (origPrice && stickyPrice) {
      var priceObserver = new MutationObserver(function () {
        stickyPrice.textContent = origPrice.textContent;
      });
      priceObserver.observe(origPrice, { childList: true, characterData: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
